import FooterControl from '@/components/FooterControl.vue';
import { BigNumber } from 'bignumber.js';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import CountInput from '@/components/countInput/index.vue';
import {
  checkAmt,
  checkNumMust,
  checkNumMain,
  validatePhone,
  checkNum,
  checkYear,
  checkMonth,
  checkDay
} from '@/utils/validate/elementMethod';
import config from '@/config/index';
import { REG_P_INT, REG_AMT, REG_T_ZEAR } from '@/utils/validate/regExp';
import { currentDate } from '@/utils/filter';
import { cityCode } from '@/utils/cityPicker/cityCode';
import medicinePrint from '@/components/medicinePrint/index.vue';
import receiptPrint from '@/components/receiptPrint/index.vue'; // 小票打印
import piecesPrint from '@/components/piecesPrint/index.vue'; // 饮片打印
import infusionPrint from '@/components/infusionPrint/index.vue'; // 输液打印
import applyPrint from '@/components/applyPrint/index.vue'; // 敷贴打印
import otherPrint from '@/components/otherPrint/index.vue'; // 其他打印
import infusionCardPrint from '@/components/infusionCardPrint/index.vue'; // 输液打印卡
import recordPrint from '@/components/recordPrint/index.vue'; // 病历打印
import noPrintTips from '@/components/noPrintTips.vue';
import print from './print';
import subFc from './suFn';

const BN = BigNumber.clone();
BN.config({
  DECIMAL_PLACES: 2,
});
// 点击空白地方关闭主诉辅助键盘
const clickoutside = {
  // 初始化指令
  bind(el, binding) {
    function documentHandler(e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false;
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是closeSymptom方法
        binding.value(e);
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.vueClickOutside = documentHandler;
    document.addEventListener('click', documentHandler);
  },
  update() {},
  unbind(el) {
    // 解除事件监听
    document.removeEventListener('click', el.vueClickOutside);
    delete el.vueClickOutside;
  },
};
export default {
  components: {
    FooterControl,
    HisAutocompleteSuggestions,
    CountInput,
    medicinePrint,
    receiptPrint,
    piecesPrint,
    infusionPrint,
    infusionCardPrint,
    applyPrint,
    otherPrint,
    noPrintTips,
    recordPrint,
  },
  mixins: [print, subFc],
  data() {
    const checkAge = (rule, value, callback) => {
      if (this.ageForm.showYear && !this.ageForm.showMonth && !this.ageForm.showDay) {
        if (this.form.patient.year === '' || !REG_T_ZEAR.test(this.form.patient.year)) {
          callback(new Error('请输入正确的年龄'));
        }
      }
      if (this.ageForm.showYear && this.ageForm.showMonth && !this.ageForm.showDay) {
        if (this.form.patient.year === '' && this.form.patient.month === '') {
          callback(new Error('请输入正确的年龄'));
        }
        if (this.form.patient.year && !REG_T_ZEAR.test(this.form.patient.year)) {
          callback(new Error('请输入正确的年龄'));
        }
        if (this.form.patient.month && !REG_T_ZEAR.test(this.form.patient.month)) {
          callback(new Error('请输入正确的年龄'));
        }
      }
      if (!this.ageForm.showYear && this.ageForm.showMonth && this.ageForm.showDay) {
        if (this.form.patient.month === '' && this.form.patient.day === '') {
          callback(new Error('请输入正确的年龄'));
        }
        if (this.form.patient.month && !REG_T_ZEAR.test(this.form.patient.month)) {
          callback(new Error('请输入正确的年龄'));
        }
        if (this.form.patient.day && !REG_T_ZEAR.test(this.form.patient.day)) {
          callback(new Error('请输入正确的年龄'));
        }
      }
      if (this.form.patient.year >= 150) {
        callback(new Error('年龄在0-150之间'));
      }
      callback();
    };
    return {
      doctorAdviceTemp: [], // 医嘱模板
      doctorAdviceDia: false, // 医嘱模板弹框
      selAdviceInfo: [], // 选中的医嘱模板
      queryInfo: {
        tempName: '',
        currentPage: 1,
        pageSize: 10,
      }, // 医嘱模板搜索条件
      totalInfo: 0, // 医嘱模板总数
      fileList2: [], // 上传病历附件
      delFiles: [], // 删除的病历附件
      uploadUrl: `${config.host}/upload/oss/upload`, // 上传病历地址
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      type: this.$route.query.type || '',
      condition: {
        injury: {
          isShowPhysicalInput: false,
          isShowOtherInput: false,
        },
      },
      pageElements: {
        isDisableCloudDrugBtn: false,
      },
      form: {
        patient: {
          patientName: '',
          gender: 1,
          ageType: '岁',
          year: '',
          month: 0,
          day: 0,
        }, // 患者信息
        inquiryInfo: {
          diagnosisResultList: [],
          doctorAdvice: '',
        }, // 病历信息
        additionalList: [], // 附加费用集合
        examList: [], // 检查治疗项集合
        medicineDrugPrescriptionList: [], // 西药处方集合
        patientChineseDrugList: [], // 中药处方集合
        patientInfusionList: [], // 输液处方集合
        patientStickingDrugGroupList: [], // 贴敷处方集合
        deleteItem: {
          deleteAdditionalIds: [],
          deleteChineseDrugPrescriptionIds: [],
          deleteExamIds: [],
          deleteInfusionPrescriptionIds: [],
          deleteStickingPrescriptionIds: [],
          deleteWesternMedicinePrescriptionIds: [],
        },
        recordVersion: '', // 订单的版本号
      },
      newform: {
        patient: {
          patientName: '',
          gender: 1,
          ageType: '岁',
          year: '',
          month: 0,
          day: 0,
        }, // 患者信息
        inquiryInfo: {
          diagnosisResultList: [],
          doctorAdvice: '',
        }, // 病历信息
        additionalList: [], // 附加费用集合
        examList: [], // 检查治疗项集合
        medicineDrugPrescriptionList: [], // 西药处方集合
        patientChineseDrugList: [], // 中药处方集合
        patientInfusionList: [], // 输液处方集合
        patientStickingDrugGroupList: [], // 贴敷处方集合
        deleteItem: {
          deleteAdditionalIds: [],
          deleteChineseDrugPrescriptionIds: [],
          deleteExamIds: [],
          deleteInfusionPrescriptionIds: [],
          deleteStickingPrescriptionIds: [],
          deleteWesternMedicinePrescriptionIds: [],
        },
        recordVersion: '', // 订单的版本号
      },
      activeName: 'second', // 默认展示tab
      examDialogVisible: false, // 载入检查治疗项弹框
      temDialogVisible: false, // 载入常用处方弹框
      additionalDialogVisible: false, // 载入附加费用弹框
      dataSource: 2, //  3：查商城  2：查询所有库(诊所库和中央库)
      options: [{
        value: 3,
        label: '全部',
      }, {
        value: 2,
        label: '成药处方',
      }, {
        value: 1,
        label: '饮片处方',
      }, {
        value: 4,
        label: '输液处方',
      }, {
        value: 7,
        label: '贴敷处方',
      }],
      selDiagnosis: [], // 诊断下拉选项
      examListAll: [], // 所有检查治疗项
      checkedExam: [], // 选中的检查治疗项
      additionalAll: [], // 所有附加费用
      checkedadditional: [], // 选中的附加费用
      perTemplateQuery: {
        currentPage: 1,
        pageSize: 10,
        tempName: '',
        tempType: 3,
      }, // 常用处方模板查询
      examQuery: {
        examName: '',
        currentPage: 1,
        pageSize: 10,
      }, // 检查治疗项分页查询
      additionalQuery: {
        tempName: '',
        currentPage: 1,
        pageSize: 10,
        tempType: 8,
      }, // 附加费用分页查询
      perTemplate: [], // 常用处方模板列表
      temTotal: 0, // 常用处方模板总数
      multipleSelection: [], // 载入常用处方选中的处方模板
      recentPrescription: [], // 最近处方列表
      recordDetial: {}, // 最近处方病历详情
      active: 0,
      activeAlone: 0, // 患者历史高亮
      paitentRecord: [], // 单个患者历史病历列表
      paitentRecordDetial: {}, // 单个患者历史病历详情
      paitentDisable: false,
      rules: {
        patient: {
          patientName: [{
            required: true,
            message: '请输入姓名',
          }],
          gender: [{
            required: true,
            message: '请选择性别',
            trigger: 'change',
          }],
          age: [{
            required: true,
            validator: checkAge,
            trigger: 'change',
          }],
          phoneNo: [{
            required: true,
            validator: validatePhone,
            trigger: 'change',
          }],
          ageType: [{
            required: true,
            message: '请选择年龄单位',
            trigger: 'change',
          }],
          year: [{
            required: true,
            validator: checkYear,
            trigger: 'change',
          }],
          month: [{
            required: true,
            validator: checkMonth,
            trigger: 'change',
          }],
          day: [{
            required: true,
            validator: checkDay,
            trigger: 'change',
          }],
        },
        inquiryInfo: {
          diagnosisResultList: [{
            required: true,
            message: '请输入诊断',
          }],
        },
        retailPrice: [{
          required: true,
          validator: checkAmt,
          trigger: 'blur',
        }],
        value: [{
          required: false,
          validator: checkNum,
          trigger: 'change',
        }],
        dosage: [{
          required: false,
          validator: checkNum,
          trigger: 'blur',
        }],
        mainNum: [{
          required: true,
          validator: checkNumMain,
          trigger: 'blur',
        }],
      },
      frequencys: [], // 用药频率远程下拉选项
      totalDosageUnits: [], // 开药量单位远程下拉选项
      positions: [], // 敷贴部位集合
      examHint: '该检查治疗项未进行配置，建议你联系诊所管理员在“系统配置”中进行配置，方便使用',
      drugHint: '该药品不在您的药库中',
      rid: this.$route.query.rid || null,
      record: { // 病历处方
        patient: {
          patientName: '',
        },
        inquiryInfo: {
          diagnosisResultString: '',
        },
        medicineDrugPrescriptionList: [{
          patientDrugList: [],
        }],
      },
      totalExam: 0, // 检查治疗项分页总数
      totalAdditional: 0, // 附加费用总数
      isClearPatient: false, // 是否可清空患者信息
      isShowSymptom: false, // 是否显示主诉辅助键盘
      symptomKeys: {
        symptom: ['发热', '头痛', '头晕', '咽痛', '鼻塞', '流涕', '咳嗽', '咳痰', '呼吸困难', '腹痛', '腹泻', '腹胀', '恶心',
          '呕吐', '反酸', '便秘', '胸痛', '心悸', '腰背痛', '关节痛', '尿频', '尿急', '尿痛', '多尿', '排尿', '困难', '水肿',
          '皮疹',
        ],
        time: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '早晨', '中午', '下午', '晚上', '分钟', '小时',
          '天', '周', '月', '年',
        ],
      },
      optionss: cityCode,
      attr: [], // 省市县
      ageForm: {
        showYear: true,
        showMonth: false,
        showDay: false,
      },
      isDisabledPrint: false, // 打印处方是否禁用
    };
  },
  directives: {
    clickoutside,
  },
  mounted() {
    // alert(33)
    // 补录病历获取当前日期
    if (this.type === 'supplement') {
      this.$set(this.form.inquiryInfo, 'clinicalTime', moment().format('YYYY-MM-DD HH:mm:ss'));
    }
    this.listRecentPrescription();
    // 如果有Id就获取患者信息
    if (this.$route.query.id) {
      this.getPatientInfo();
    }
    this.getTableData();
  },
  methods: {
    // 关闭主诉弹框
    closeSymptom() {
      this.isShowSymptom = false;
    },
    // 主诉辅助键盘输入
    handleKeyPress(e, key) {
      const strs = e.target.dataset.str;
      if (!strs) return;
      if (this.form.inquiryInfo.symptom) {
        this.form.inquiryInfo.symptom += `${key}${strs}`;
      } else {
        this.$set(this.form.inquiryInfo, 'symptom', strs);
      }
    },
    // 设置诊断下拉框选项值
    setDiagnosisSel(e) {
      this.selDiagnosis = e;
    },
    // 添加诊断的值
    setDiagnosis(e) {
      if (!e) {
        const inputVal = document.querySelector('.spe-sel-val .el-select__input').value;
        const diagnosis = this.form.inquiryInfo.diagnosisResultList.filter(item => item === inputVal);
        if (diagnosis.length === 0 && inputVal !== '') {
          this.form.inquiryInfo.diagnosisResultList.push(inputVal);
          this.$refs.form.validateField('inquiryInfo.diagnosisResultList');
        }
      }
    },
    supData(total, index) {
      if (total === '') {
        this.form.examList[index].total = 1;
      }
    },
    // 保存为常用处方-成药
    saveChinesePatentTemp(info) {
      if (info.patientDrugList[0].drugName === '') {
        this.$message({
          type: 'error',
          message: '请至少添加一种药品！',
        });
        return;
      }
      this.$prompt('处方名称', '存为常用处方', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[^\s]*$/,
        inputErrorMessage: '请输入处方名称',
      }).then(({
        value
      }) => {
        this.addChinesePatentTemp(value, info);
      }).catch(() => {});
    },
    // 保存为常用处方-成药
    addChinesePatentTemp(value, info) {
      this.$api.clinicManagement.insertDrugRecipe({
        ...info,
        tempName: value,
        tempAuthority: 1, // 1:个人模板  2：诊所模板'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '保存模板成功！',
        });
      });
    },
    // 保存为常用处方-饮片
    saveChineseDrugTemp(info) {
      console.log(info);
      if (info.patientChineseDrugPiecesList[0].drugName === '') {
        this.$message({
          type: 'error',
          message: '请至少添加一种药品！',
        });
        return;
      }
      this.$prompt('处方名称', '存为常用处方', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[^\s]*$/,
        inputErrorMessage: '请输入处方名称',
      }).then(({
        value
      }) => {
        this.addChineseDrugTemp(value, info);
      }).catch(() => {});
    },
    // 保存为常用处方-饮片
    addChineseDrugTemp(value, info) {
      this.$api.clinicManagement.insertChineseDrugRecipe({
        ...info,
        tempName: value,
        tempAuthority: 1, // 1:个人模板  2：诊所模板'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '保存模板成功！',
        });
      });
    },
    // 保存为常用处方-输液
    saveInfusionTemp(info) {
      console.log(info);
      if (info.patientInfusionGroupList[0].patientDrugList[0].drugName === '') {
        this.$message({
          type: 'error',
          message: '请至少添加一种药品！',
        });
        return;
      }
      this.$prompt('处方名称', '存为常用处方', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[^\s]*$/,
        inputErrorMessage: '请输入处方名称',
      }).then(({
        value
      }) => {
        this.addInfusionTemp(value, info);
      }).catch(() => {});
    },
    // 保存为常用处方-输液
    addInfusionTemp(value, info) {
      this.$api.clinicManagement.insertInfusionRecipe({
        ...info,
        tempName: value,
        tempAuthority: 1, // 1:个人模板  2：诊所模板'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '保存模板成功！',
        });
      });
    },
    // 保存为常用处方-贴敷
    saveStickTemp(info, index) {
      const list = info.patientStickingDrugList.filter(i => i.drugName !== '');
      if (list.length < 1) {
        this.$message({
          message: '请添加贴敷处方药品',
          type: 'error',
        });
        return;
      }
      let isTrueStickDrug = true;
      info.patientStickingDrugList.forEach((it, indexs) => {
        if (it.drugName === '' && !it.dosage) return;
        const isEmpty = it.drugName === '' || it.dosage === '' || it.dosage <= 0 || !it.dosage;
        if (isEmpty) {
          this.$message({
            message: '请完善贴敷处方的信息',
            type: 'error',
          });
          this.$set(this.form.patientStickingDrugGroupList[index]
            .patientStickingDrugList[indexs], 'error', true);
          isTrueStickDrug = false;
        }
      });
      if (!isTrueStickDrug) return;
      const newList = cloneDeep(info);
      // 删除空白栏
      const lists = info.patientStickingDrugList.filter(it => it.drugName !== '');
      newList.patientStickingDrugList = lists;
      this.$prompt('处方名称', '存为常用处方', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[^\s]*$/,
        inputErrorMessage: '请输入处方名称',
      }).then(({
        value,
      }) => {
        this.addStickTemp(value, newList);
      }).catch(() => {});
    },
    // 保存为常用处方-贴敷
    addStickTemp(value, info) {
      this.$api.clinicManagement.insertStickingDrugGroupRecipe({
        ...info,
        tempName: value,
        tempAuthority: 1, // 1:个人模板  2：诊所模板'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '保存模板成功！',
        });
      });
    },
    // 获取患者信息
    getPatientInfo() {
      this.$api.member.patientDetail({
        patientId: this.$route.query.id,
      }).then((res) => {
        this.form.patient = {
          patientName: res.name,
          gender: res.gender,
          ageType: res.ageType,
          phoneNo: res.phone,
          idCardNo: res.idCard,
          age: res.age,
          year: res.year,
          month: res.month,
          day: res.day,
          patientId: res.patientId,
          address: res.address || '', // 详细地址
          allergyHistory: res.allergyHistory, // 过敏史
        };
        // 地址信息回填
        if (res.provinceCode && res.cityCode && res.districtCode) {
          this.attr = [parseInt(res.provinceCode, 10), parseInt(res.cityCode, 10), parseInt(res.districtCode, 10)];
        }
        this.$set(this.form.inquiryInfo, 'allergyHistory', res.allergyHistory);
        this.listHistoryRecordByPaitentId(res.patientId);
        this.paitentDisable = true;
        this.dayHandle();
      });
    },
    // 获取病历信息
    getTableData() {
      if (this.rid) {
        this.$api.outPatient.getRecord({
          recordId: this.rid,
        }).then((res) => {
          const conForm = res;
          const newList = res.inquiryInfo;

          if (newList === '') {
            conForm.inquiryInfo = {
              diagnosisResultList: [],
            };
          } else {
            // 诊断显示格式化
            conForm.inquiryInfo.diagnosisResultList = res.inquiryInfo.diagnosisResultList.map(item => item.diseaseName);
            // 是否展开体格检查
            if (conForm.inquiryInfo.temperature || conForm.inquiryInfo.weight || conForm.inquiryInfo.heartRate ||
              conForm.inquiryInfo.sbp || conForm.inquiryInfo.dbp || conForm.inquiryInfo.otherPhysique) {
              this.condition.injury.isShowPhysicalInput = true;
            }
            // 是否默认展开默认病史
            if (conForm.inquiryInfo.previousHistory || conForm.inquiryInfo.personalHistory || conForm.inquiryInfo.familyHistory) {
              this.condition.injury.isShowOtherInput = true;
            }
          }
          const sticklist = conForm.patientStickingDrugGroupList;
          sticklist.forEach((item, index) => {
            conForm.patientStickingDrugGroupList[index].position = JSON.parse(item.position);
          });
          this.form = conForm;
          this.paitentDisable = true; // 患者信息不可编辑

          // 地址信息回填
          if (conForm.patient.provinceCode && conForm.patient.cityCode && conForm.patient.districtCode) {
            this.attr = [parseInt(conForm.patient.provinceCode, 10), parseInt(conForm.patient.cityCode, 10), parseInt(conForm.patient.districtCode, 10)];
          }
          this.selDiagnosis = this.form.inquiryInfo.diagnosisResultList; // 诊断下拉框选项
          // 删除处方id列表
          this.form.deleteItem = {
            deleteAdditionalIds: [],
            deleteChineseDrugPrescriptionIds: [],
            deleteExamIds: [],
            deleteInfusionPrescriptionIds: [],
            deleteStickingPrescriptionIds: [],
            deleteWesternMedicinePrescriptionIds: [],
          };
          if (this.form.inquiryInfo.inquiryAttachmentList && this.form.inquiryInfo
            .inquiryAttachmentList.length > 0) {
            this.fileList2 = this.form.inquiryInfo.inquiryAttachmentList.map(item => ({
              name: `${item.fileName}.${item.fileType}`,
              url: item.newUri,
            }));
          }
          // 年龄初步的处理让年月日按逻辑显示
          this.dayHandle();
          this.listHistoryRecordByPaitentId(this.form.patient.patientId);
        });
      }
    },
    // 检查治疗项输入框失焦
    examNameBlur(name, index) {
      this.form.examList[index].examName = name;
    },
    // 成药药品输入框失焦
    chinesePatentDrugBlur(name, index, drugindex) {
      this.form.medicineDrugPrescriptionList[index].patientDrugList[drugindex].drugName = name;
    },
    // 饮片药品输入框失焦
    chinesePieceDrugBlur(name, index, drugindex) {
      this.form.patientChineseDrugList[index].patientChineseDrugPiecesList[drugindex].drugName =
        name;
    },
    // 输液药品输入框失焦
    infusionDrugBlur(name, index, indexs, drugindex) {
      this.form.patientInfusionList[index].patientInfusionGroupList[indexs].patientDrugList[
        drugindex].drugName = name;
    },
    // 贴敷药品输入框失焦
    stickingBlur(name, index, drugindex) {
      this.form.patientStickingDrugGroupList[index].patientStickingDrugList[drugindex].drugName =
        name;
    },
    // 用药频率下拉选项
    remoteMethod1(query) {
      this.getComValue(2, query);
    },
    // 开药量单位下拉选项
    remoteUnit(query) {
      this.getComValue(4, query);
    },
    // 获取贴敷部位下拉选项
    remoteMethod(query) {
      this.getComValue(12, query);
    },
    // 获取公共参数
    getComValue(types, query) {
      const name = query === '' || (Array.isArray(query) && query.length === 0) ? '' : query;
      this.$api.drugControl.searchDictionary({
        type: types,
        cnName: name,
      }).then((res) => {
        const list = res.dictList.map(item => ({
          value: item.cnName
        }));
        if (res.dictList.length > 0) {
          switch (types) {
            case 2:
              this.frequencys = list; // 用药频率
              break;
            case 4:
              this.totalDosageUnits = list; // 用量单位
              break;
            case 12:
              this.positions = list; // 贴敷部位
              break;
            default:
              break;
          }
        }
      });
    },
    /* 模糊搜索
    成药处方：1=用法 2=用药频率 3=单次剂量 4=开药量
    饮片处方：6=用法 2=用药频率 7=服用要求 9=备注
    输液处方：10=用法 2=用药频率 11=滴速 3=单次剂量 4=开药量
    贴敷处方：13=用法 14=调法 12=贴敷部位
    */
    queryCom(query, cb, types) {
      this.$api.drugControl.searchDictionary({
        type: types,
        cnName: query,
      }).then((res) => {
        const list = res.dictList.map(item => ({
          value: item.cnName
        }));
        if (res.dictList.length > 0) {
          cb(list);
        } else {
          cb([]);
        }
      });
    },
    // 根据会员电话或者姓名查询下拉框
    querySearchPatient(queryString, cb) {
      let list = [];
      this.form.patient.patientName = queryString;
      this.$api.outPatient.listclinicPatientByNameOrPhone({
        patientConditions: queryString,
      }).then((res) => {
        list = res.patinetList.map(item => ({
          birthday: item.birthday,
          patientName: item.patientName,
          phoneNo: item.phoneNo,
          gender: item.gender,
          ageCom: `${item.age}${item.ageType}`,
          age: item.age,
          ageType: item.ageType,
          year: item.year,
          month: item.month,
          day: item.day,
          patientId: item.patientId,
          idCardNo: item.idCardNo,
          allergyHistory: item.allergyHistory || '',
          provinceCode: item.provinceCode,
          cityCode: item.cityCode,
          districtCode: item.districtCode,
          address: item.address,
        }));
        cb(list);
      });
    },
    // 选中患者
    handleSelect(e) {
      this.form.patient = {
        birthday: e.birthday,
        patientName: e.patientName,
        gender: e.gender,
        ageType: e.ageType,
        phoneNo: e.phoneNo,
        year: e.year,
        month: e.month,
        day: e.day,
        age: e.age,
        idCardNo: e.idCardNo,
        patientId: e.patientId,
        address: e.address,
      };
      if (e.provinceCode && e.cityCode && e.districtCode) {
        this.attr = [parseInt(e.provinceCode, 10), parseInt(e.cityCode, 10), parseInt(e.districtCode, 10)];
      }
      this.$set(this.form.inquiryInfo, 'allergyHistory', e.allergyHistory);
      this.listHistoryRecordByPaitentId(e.patientId);
      this.paitentDisable = true;
      this.isClearPatient = true; // 显示删除按钮
      // 年龄处理
      this.dayHandle();
    },
    // 清除患者
    clearPatient() {
      this.form.patient = {
        patientName: '',
        phoneNo: '',
        age: '',
        idCardNo: '',
        patientId: null,
      };
      this.form.inquiryInfo.allergyHistory = '';
      this.attr = []; // 清空地址信息
      this.paitentDisable = false;
      this.$nextTick(() => {
        this.$refs.form.clearValidate(); // 移除校验结果
      });
      this.isClearPatient = false; // 隐藏删除按钮
      this.paitentRecord = []; // 清空最近处方
      this.paitentRecordDetial = {}; // 清空处方详情
    },
    // 获取最近处方
    listRecentPrescription() {
      this.$api.outPatient.listRecentPrescription().then((res) => {
        this.recentPrescription = res;
        // 获取列表第一条数据处方详情
        if (this.recentPrescription.length > 0) {
          this.choosePrescription(this.recentPrescription[0].recordId, 0, 2);
        }
      });
    },
    // 获取单个患者历史病历
    listHistoryRecordByPaitentId(id) {
      this.$api.outPatient.listHistoryRecordByPaitentId({
        patientId: id,
      }).then((res) => {
        this.paitentRecord = res;
        // 获取列表第一条数据处方详情
        if (this.paitentRecord.length > 0) {
          this.choosePrescription(this.paitentRecord[0].recordId, 0, 1);
        } else {
          this.paitentRecordDetial = {}; // 清空处方详情
        }
      });
    },
    // 患者病历信息
    choosePrescription(id, index, type) {
      if (type === 1) {
        this.activeAlone = index;
      } else {
        this.active = index;
      }
      this.$api.outPatient.getPatientRecord({
        recordId: id,
      }).then((res) => {
        console.log(res);
        if (type === 1) {
          this.paitentRecordDetial = res;
        } else {
          this.recordDetial = res;
        }
      });
    },
    // 选中诊断-历史记录
    chooseDiagnosis(list) {
      const newList = this.form.inquiryInfo.diagnosisResultList;
      list.forEach((item) => {
        newList.push(item.diseaseName);
      });
      this.form.inquiryInfo.diagnosisResultList = Array.from(new Set(newList));
      this.selDiagnosis = this.form.inquiryInfo.diagnosisResultList;
      this.$message({
        message: '添加成功',
        type: 'success',
      });
    },
    // 选中主诉
    chooseSymptom(text) {
      console.log(text);
      if (this.form.inquiryInfo.symptom) {
        this.form.inquiryInfo.symptom += text;
      } else {
        this.$set(this.form.inquiryInfo, 'symptom', text);
      }
      this.$message({
        message: '添加成功',
        type: 'success',
      });
    },
    // 选中检查治疗项-历史记录
    chooseExamList(list) {
      const cloneList = cloneDeep(list);
      cloneList.forEach((item) => {
        this.form.examList.push({
          examId: item.examId,
          examName: item.examName,
          price: item.price,
          total: item.total || 1,
        });
      });
      this.$message({
        message: '添加成功',
        type: 'success',
      });
    },
    // 选中贴敷处方-历史记录
    chooseStick(list) {
      const newlist = cloneDeep(list);
      newlist.position = JSON.parse(list.position);
      // newlist.id = '';
      // newlist.recordId = '';
      this.form.patientStickingDrugGroupList.push(newlist);
      this.$message({
        message: '添加成功',
        type: 'success',
      });
    },
    // 选中输液处方-历史记录
    chooseInfusion(list) {
      // newlist.id = '';
      // newlist.prescription = '';
      // newlist.recordId = '';
      const cloneList = cloneDeep(list);
      const lists = cloneList.patientInfusionGroupList.map(item => ({
        ...item,
        startTime: moment().format('YYYY-MM-DD HH:mm:ss'),
      }));
      const newlist = {
        dataSource: this.dataSource, // 0:诊所本地库 1:中央库  2:诊所本地库和中央库 3:商城库 5:未知
        patientInfusionGroupList: lists,
        // prescription: '',
      };
      this.form.patientInfusionList.push(newlist);
      this.$message({
        message: '添加成功',
        type: 'success',
      });
    },
    // 选中饮片处方-历史记录
    chooseChineseDrug(list) {
      const newlist = cloneDeep(list);
      // newlist.paChDrugId = '';
      // newlist.prescription = '';
      // newlist.recordId = '';
      this.form.patientChineseDrugList.push(newlist);
      this.$message({
        message: '添加成功',
        type: 'success',
      });
    },
    // 选中成药处方-历史记录
    chooseMedicineDrug(list) {
      const newlist = cloneDeep(list);
      // newlist.prescription = '';
      // newlist.recordId = '';
      this.form.medicineDrugPrescriptionList.push(newlist);
      this.$message({
        message: '添加成功',
        type: 'success',
      });
    },
    // 获取检查治疗项
    getHospitalExamList(type) {
      if (type === 1) this.examQuery.currentPage = 1;
      this.$api.clinicManagement.listPagedExam(this.examQuery).then((res) => {
        console.log(res);
        this.examListAll = res.examList;
        this.totalExam = res.totalSize || 0;
      });
    },
    // 检查治疗项翻页
    pageChangeExam(e) {
      this.examQuery.currentPage = e;
      this.getHospitalExamList();
    },
    // 勾选检查治疗项
    handleExamChange(val) {
      this.checkedExam = val;
    },
    // 选择检查治疗项
    checkExam() {
      console.log(this.form.examList);
      this.checkedExam.forEach((item) => {
        this.form.examList.push({
          examId: item.examId,
          examName: item.examName,
          price: item.examPrice,
          total: 1, // 数量：默认为1
        });
      });
      this.checkedExam = []; // 清空选项
      this.examDialogVisible = false;
    },
    // 获取常用处方模板
    getTemData(type) {
      // tempAuthority 1:个人处方 2：诊所处方 3：常用处方
      if (type === 1) {
        this.perTemplateQuery.currentPage = 1;
      }
      this.$api.clinicManagement.lisTemplate({
        ...this.perTemplateQuery,
        tempAuthority: 3,
      }).then((res) => {
        console.log(res);
        this.temTotal = res.totalSize;
        this.perTemplate = res.templates;
      });
    },
    // 载入常用处方模板
    loadTemplate() {
      this.temDialogVisible = true;
      if (this.temTotal === 0) {
        this.getTemData(1);
      }
    },
    // 常用处方翻页
    pageChangeInfo(e) {
      this.perTemplateQuery.currentPage = e;
      this.getTemData();
    },
    // 勾选常用处方模板
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 勾选医嘱模板
    handledocAdviceTem(val) {
      this.selAdviceInfo = val;
    },
    // 确认选中处方模板
    chooseTemplate() {
      this.multipleSelection.forEach((item) => {
        if (item.tempType === 1) { // 饮片处方
          this.$api.clinicManagement.getChineseDrugRecipe({
            templateId: item.id,
            type: 2,
          }).then((res) => {
            console.log(res);
            // const ele = res;
            // ele.prescription = '';
            // ele.paChDrugId = '';
            this.form.patientChineseDrugList.push(res);
          });
        } else if (item.tempType === 2) { // 成药处方
          this.$api.clinicManagement.getDrugRecipe({
            templateId: item.id,
            type: 2,
          }).then((res) => {
            console.log(res);
            const ele = {
              dataSource: this.dataSource, // 0:诊所本地库 1:中央库  2:诊所本地库和中央库 3:商城库 5:未知
              patientDrugList: res.patientDrugList,
              // prescription: '',
            };
            this.form.medicineDrugPrescriptionList.push(ele);
          });
        } else if (item.tempType === 4) { // 输液处方
          this.$api.clinicManagement.getInfusionRecipe({
            templateId: item.id,
            type: 2,
          }).then((res) => {
            console.log(res);
            const list = res.patientInfusionGroupList.map(item => ({
              ...item,
              startTime: moment().format('YYYY-MM-DD HH:mm:ss'),
            }));
            const ele = {
              dataSource: this.dataSource, // 0:诊所本地库 1:中央库  2:诊所本地库和中央库 3:商城库 5:未知
              patientInfusionGroupList: list,
              // prescription: '',
            };
            this.form.patientInfusionList.push(ele);
          });
        } else if (item.tempType === 7) { // 贴敷处方
          this.$api.clinicManagement.getStickingDrugGroupRecipe({
            templateId: item.id,
            type: 2,
          }).then((res) => {
            console.log(res);
            const newlist = res;
            newlist.position = JSON.parse(res.position);
            // newlist.id = '';
            this.form.patientStickingDrugGroupList.push(newlist);
          });
        }
      });
      this.multipleSelection = [];
      this.$refs.perTemplate.clearSelection(); // 清空勾选的处方模板
      this.temDialogVisible = false;
    },
    // 选择常用医嘱模板
    chooseDoctorAdvice() {
      let str = '';
      this.selAdviceInfo.forEach((item) => {
        str += item.tempDesc;
      });
      if (this.form.inquiryInfo.doctorAdvice) {
        this.form.inquiryInfo.doctorAdvice += str;
      } else {
        this.form.inquiryInfo.doctorAdvice = str;
      }
      this.selAdviceInfo = [];
      this.$refs.doctorAdviceTemp.clearSelection(); // 清空勾选的医嘱模板
      this.doctorAdviceDia = false;
    },
    // 查询医嘱模板
    addDocAdviceTemp() {
      this.queryInfo.tempName = '';
      this.getDataInfo();
      this.doctorAdviceDia = true;
    },
    // 获取医嘱模板
    getDataInfo(type) {
      if (type === 1) this.queryInfo.currentPage = 1;
      this.$api.clinicManagement.lisTemplate({
        ...this.queryInfo,
        tempType: 6, //  1:中药处方模板 2:西药处方模板  3:全部 4:输液卡模板 6:医嘱模板 7:贴敷模板
      }).then((res) => {
        console.log(res);
        this.totalInfo = res.totalSize;
        this.doctorAdviceTemp = res.templates;
      });
    },
    // 常用医嘱翻页
    pageChangeAdvInfo(e) {
      this.queryInfo.currentPage = e;
      this.getDataInfo();
    },
    // 查询检查治疗项
    querySearch(queryString, cb, index) {
      this.checkDrugExam(index);
      let hospitalExamList = [];
      this.$api.outPatient.getHospitalExamList({
        examName: queryString,
      }).then((res) => {
        console.log(res);
        hospitalExamList = res.map(item => ({
          examName: item.examName,
          examId: item.examId,
          price: item.examPrice,
          total: 1,
        }));
        cb(hospitalExamList);
      });
    },
    // 下拉选中检查治疗项
    handleSelectExam(item, index) {
      this.form.examList[index] = item;
      this.$set(this.form.examList, index, item);
    },
    /* 操作成药处方 */
    handleAddChinesePatent() {
      const ele = {
        dataSource: this.dataSource, // 0:诊所本地库 1:中央库  2:诊所本地库和中央库 3:商城库 5:未知
        patientDrugList: [{
          drugName: '',
          usage: '',
          frequency: '',
          dosage: '',
          dosageUnit: '',
          univalence: '0.00',
          totalDosage: null,
          totalDosageUnit: '',
        }],
      };
      this.form.medicineDrugPrescriptionList.push(ele);
    },
    // 删除成药处方
    handleDelChinesePatent(index, id) {
      this.$confirm('确定要删除该处方吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (id) {
          this.form.deleteItem.deleteWesternMedicinePrescriptionIds.push(id);
        }
        this.form.medicineDrugPrescriptionList.splice(index, 1);
      }).catch(() => {});
    },
    // 添加药品-成药
    handleAddChinesePatentDrug(index) {
      const ele = {
        drugName: '',
        usage: '',
        frequency: '',
        dosage: '',
        dosageUnit: '',
        univalence: '0.00',
        totalDosage: null,
        totalDosageUnit: '',
      };
      this.form.medicineDrugPrescriptionList[index].patientDrugList.push(ele);
    },
    // 删除成药处方药品
    handleDelChinesePatentDrug(index, drugIndex) {
      this.form.medicineDrugPrescriptionList[index].patientDrugList.splice(drugIndex, 1);
    },
    // 模糊搜索-成药
    querySearchChinesePatentDrug(param, cb, index, drugindex) {
      this.checkDrugCom(index, drugindex);
      let drugList = [];
      this.$api.outPatient.getPrescription({
        drugName: param,
        drugType: 100,
        dataSource: this.dataSource,
      }).then((res) => {
        drugList = res.map(item => ({
          drugName: item.drugName,
          usage: item.usage, // 用法
          frequency: item.frequency, // 用药频率
          dosage: item.singleDosage, // 单次剂量
          dosageUnit: item.singleDosageUnit, // 单次剂量单位
          totalDosage: item.drugSalePojos[0] && item.drugSalePojos[0].dosage && item.drugSalePojos[0].dosage > 0 ? item.drugSalePojos[0].dosage : 1, // 开药量
          totalDosageUnit: item.drugSalePojos[0] && item.drugSalePojos[0].unitName ? item.drugSalePojos[0].unitName : '', // 开药量单位
          univalence: item.drugSalePojos[0] && item.drugSalePojos[0].drugSalePrice ? item.drugSalePojos[0].drugSalePrice : 0, // 开药量价格
          specification: item.specification, // 规格
          manufacturer: item.manufacturer, // 厂家
          dataSource: item.dataSource, // 药品来源
          drugId: item.id,
          drugSalePojos: item.drugSalePojos,
          inventoryCount: item.inventoryCount || 0, // 库存
          drugUnitPojo: item.drugUnitPojo,
          inventoryStr: item.inventoryStr,
          isShopDrugs: item.isShopDrugs || 0,
        }));
        console.log(res);
        cb(drugList);
      });
    },
    // 选中成药药品
    handleSelectChinesePatentDrug(item, index, drugindex) {
      // 列表禁止选择相同的药品
      const hasSameDrug = this.form.medicineDrugPrescriptionList[index].patientDrugList.map(item => item.drugId).indexOf(item.drugId);
      if (hasSameDrug !== -1) {
        this.$message({
          type: 'warning',
          message: '该药已在列表中！',
        });
        return;
      }
      this.form.medicineDrugPrescriptionList[index].patientDrugList[drugindex] = item;
      this.$set(this.form.medicineDrugPrescriptionList[index].patientDrugList, drugindex, item);
      console.log(this.form.medicineDrugPrescriptionList[index].patientDrugList[drugindex]);
      if (drugindex + 1 === this.form.medicineDrugPrescriptionList[index].patientDrugList.length) {
        this.handleAddChinesePatentDrug(index);
      }
    },

    /* 操作中药饮片处方 */
    handleAddChinesePiece() {
      const ele = {
        totalDosage: 1,
        dailyDosage: '',
        frequency: '',
        requirement: '',
        dataSource: this.dataSource,
        patientChineseDrugPiecesList: [{
          drugName: '',
          value: null,
          univalence: '0.00',
          comment: '',
          unit: 'g',
        }],
      };
      this.form.patientChineseDrugList.push(ele);
    },
    // 删除饮片处方
    handleDelChinesePiece(index, id) {
      this.$confirm('确定要删除该处方吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (id) {
          this.form.deleteItem.deleteChineseDrugPrescriptionIds.push(id);
        }
        this.form.patientChineseDrugList.splice(index, 1);
      }).catch(() => {});
    },
    // 添加饮片处方
    handleAddChinesePieceDrug(index) {
      const ele = {
        drugName: '',
        value: null,
        univalence: '0.00',
        comment: '',
        unit: 'g',
      };
      this.form.patientChineseDrugList[index].patientChineseDrugPiecesList.push(ele);
    },
    // 删除饮片处方药品
    handleDelChinesePieceDrug(index, drugindex) {
      this.form.patientChineseDrugList[index].patientChineseDrugPiecesList.splice(drugindex, 1);
    },
    // 模糊搜索饮片处方药品
    querySearchChinesePieceDrug(param, cb, index, indexs) {
      this.checkDrug(index, indexs);
      let drugList = [];
      this.$api.outPatient.getPrescription({
        drugName: param,
        drugType: 2,
        dataSource: this.dataSource,
      }).then((res) => {
        console.log(res);
        drugList = res.map(item => ({
          drugName: item.drugName,
          value: item.drugSalePojos.length > 0 && item.drugSalePojos[0].dosage > 0 ? item
            .drugSalePojos[0].dosage : null,
          univalence: item.drugSalePojos.length > 0 ? item.drugSalePojos[0]
            .drugSalePrice : 0.00,
          unit: item.drugSalePojos.length > 0 ? item.drugSalePojos[0].unitName : 'g',
          specification: item.specification, // 规格
          manufacturer: item.manufacturer, // 厂家
          drugId: item.id,
          dataSource: item.dataSource,
          inventoryCount: item.inventoryCount || 0, // 库存
          comment: item.comment, // 备注
          inventoryStr: item.inventoryStr, // 库存
          isShopDrugs: item.isShopDrugs || 0, // 是否商城一键入库药品
        }));
        cb(drugList);
      });
    },
    // 选中饮片处方药品
    handleSelectChinesePieceDrug(item, index, drugindex) {
      // 列表禁止选择相同的药品
      const hasSameDrug = this.form.patientChineseDrugList[index].patientChineseDrugPiecesList.map(item => item.drugId).indexOf(item.drugId);
      if (hasSameDrug !== -1) {
        this.$message({
          type: 'warning',
          message: '该药已在列表中！',
        });
        return;
      }
      this.$set(this.form.patientChineseDrugList[index].patientChineseDrugPiecesList, drugindex,
        item);
      // 数量为空时，光标定位到数量输入框
      this.$nextTick(() => {
        document.querySelectorAll(`.value-input${index}`)[drugindex].querySelector('input')
          .focus();
      });
      // 自动添加一行
      if (drugindex + 1 === this.form.patientChineseDrugList[index].patientChineseDrugPiecesList
        .length) {
        this.handleAddChinesePieceDrug(index);
      }
    },
    /* 操作输液处方 */
    handleAddInfusion() {
      const ele = {
        patientInfusionGroupList: [{
          usage: '',
          useRate: '',
          drippingSpeed: '',
          startTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          dayCount: 1,
          patientDrugList: [{
            drugName: '',
            dosage: '',
            dosageUnit: '',
            totalDosage: null,
            totalDosageUnit: '',
            skinTest: '',
            univalence: '0.00',
          }],
        }],
      };
      this.form.patientInfusionList.push(ele);
    },
    // 删除输液处方
    handleDelInfusion(index, id) {
      this.$confirm('确定要删除该处方吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (id) {
          this.form.deleteItem.deleteInfusionPrescriptionIds.push(id);
        }
        this.form.patientInfusionList.splice(index, 1);
      }).catch(() => {});
    },
    // 删除输液处方组
    delInfusionGroup(index, indexs, id) {
      if (this.form.patientInfusionList[index].patientInfusionGroupList.length === 1) {
        this.handleDelInfusion(index, id);
      } else {
        this.form.patientInfusionList[index].patientInfusionGroupList.splice(indexs, 1);
      }
    },
    // 添加输液处方组
    addInfusionGroup(index) {
      const ele = {
        usage: '',
        useRate: '',
        drippingSpeed: '',
        startTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        dayCount: 1,
        dataSource: this.dataSource,
        patientDrugList: [{
          drugName: '',
          dosage: '',
          dosageUnit: '',
          totalDosage: null,
          totalDosageUnit: '',
          skinTest: '',
          univalence: 0.00,
        }],
      };
      this.form.patientInfusionList[index].patientInfusionGroupList.push(ele);
    },
    // 添加输液处方药品
    handleAddInfusionDrug(index, indexs) {
      const ele = {
        drugName: '',
        dosage: '',
        dosageUnit: '',
        totalDosage: null,
        totalDosageUnit: '',
        skinTest: '',
        univalence: '0.00',
      };
      this.form.patientInfusionList[index].patientInfusionGroupList[indexs].patientDrugList.push(
        ele);
    },
    // 删除输液处方药品
    handleDelInfusionDrug(index, indexs, drugindex) {
      this.form.patientInfusionList[index].patientInfusionGroupList[indexs].patientDrugList.splice(
        drugindex, 1);
    },
    // 模糊查询输液处方药品
    querySearchInfusionDrug(param, cb, index, indexs, drugindex) {
      this.checkDrugIn(index, indexs, drugindex);
      let drugList = [];
      this.$api.outPatient.getPrescription({
        drugName: param,
        drugType: 10,
        dataSource: this.dataSource,
      }).then((res) => {
        console.log(res);
        drugList = res.map(item => ({
          drugName: item.drugName,
          totalDosage: item.drugSalePojos.length > 0 && item.drugSalePojos[0].dosage > 0 ?
            item.drugSalePojos[0].dosage : null,
          univalence: item.drugSalePojos.length > 0 ? item.drugSalePojos[0]
            .drugSalePrice : '0.00',
          totalDosageUnit: item.drugSalePojos.length > 0 ? item.drugSalePojos[0]
            .unitName : 'g',
          dosageUnit: item.singleDosageUnit,
          dosage: item.singleDosage,
          specification: item.specification, // 规格
          manufacturer: item.manufacturer, // 厂家
          drugId: item.id,
          drugSalePojos: item.drugSalePojos, // 开药量单位
          dataSource: item.dataSource,
          skinTest: '',
          inventoryCount: item.inventoryCount || 0, // 库存
          drugUnitPojo: item.drugUnitPojo,
          inventoryStr: item.inventoryStr, // 库存
          isShopDrugs: item.isShopDrugs || 0, // 是否商城一键入库药品
        }));
        cb(drugList);
      });
    },
    // 选中输液处方药品
    handleSelectInfusionDrug(item, index, indexs, drugindex) {
      // 列表禁止选择相同的药品
      const hasSameDrug = this.form.patientInfusionList[index].patientInfusionGroupList[indexs]
        .patientDrugList.map(item => item.drugId).indexOf(item.drugId);
      if (hasSameDrug !== -1) {
        this.$message({
          type: 'warning',
          message: '该药已在列表中！',
        });
        return;
      }
      this.$set(this.form.patientInfusionList[index].patientInfusionGroupList[indexs]
        .patientDrugList, drugindex, item);
      // 自动添加一行
      if (drugindex + 1 === this.form.patientInfusionList[index].patientInfusionGroupList[indexs]
        .patientDrugList.length) {
        this.handleAddInfusionDrug(index, indexs);
      }
    },
    /* 操作敷贴处方 */
    handleAddStick() {
      const ele = {
        usage: '', // 用法
        adjusting: '', // 调法
        minuteNumber: '', // 时长
        count: '', // 数量
        position: '', // 部位
        retailPrice: '', // 金额
        patientStickingDrugList: [{
          drugName: '', // 药品名字
          dosage: null, // 开药量
          dosageUnit: 'g', // 开药量单位
        }],
      };
      this.form.patientStickingDrugGroupList.push(ele);
    },
    // 模糊搜索贴敷药品
    querySearchSticking(param, cb, index, indexs) {
      this.checkDrugStick(index, indexs);
      let drugList = [];
      this.$api.outPatient.getPrescription({
        drugName: param,
        drugType: 9,
        dataSource: this.dataSource,
      }).then((res) => {
        console.log(res);
        drugList = res.map(item => ({
          drugName: item.drugName,
          dosage: item.drugSalePojos.length > 0 && item.drugSalePojos[0].dosage > 0 ? item
            .drugSalePojos[0].dosage : null,
          dosageUnit: item.drugSalePojos.length > 0 ? item.drugSalePojos[0].unitName :
            'g',
          specification: item.specification, // 规格
          manufacturer: item.manufacturer, // 厂家
          drugId: item.id,
          inventoryCount: item.inventoryCount || 0, // 库存
          dataSource: item.dataSource,
          inventoryStr: item.inventoryStr, // 库存
          isShopDrugs: item.isShopDrugs || 0, // 是否商城一键入库药品
        }));
        cb(drugList);
      });
    },
    // 选中贴敷药品
    handleSelectSticking(item, index, drugindex) {
      // 列表禁止选择相同的药品
      const hasSameDrug = this.form.patientStickingDrugGroupList[index].patientStickingDrugList.map(item => item.drugId).indexOf(item.drugId);
      if (hasSameDrug !== -1) {
        this.$message({
          type: 'warning',
          message: '该药已在列表中！',
        });
        return;
      }
      this.form.patientStickingDrugGroupList[index].patientStickingDrugList[drugindex] = item;
      this.$set(this.form.patientStickingDrugGroupList[index].patientStickingDrugList, drugindex,
        item);
      // 数量为空时，光标定位到数量输入框
      this.$nextTick(() => {
        document.querySelectorAll('.dosage-input')[drugindex].querySelector('input').focus();
      });
      // 自动添加一行
      if (drugindex + 1 === this.form.patientStickingDrugGroupList[index].patientStickingDrugList
        .length) {
        this.handleAddStickDrug(index);
      }
    },
    // 添加敷贴药品
    handleAddStickDrug(index) {
      const ele = {
        drugName: '', // 药品名字
        dosage: null, // 开药量
        dosageUnit: 'g', // 开药量单位
      };
      this.form.patientStickingDrugGroupList[index].patientStickingDrugList.push(ele);
    },
    // 删除敷贴药品
    handleDelStickDrug(index, indexdrug) {
      this.form.patientStickingDrugGroupList[index].patientStickingDrugList.splice(indexdrug, 1);
    },
    // 删除敷贴处方
    handleDelStick(index, id) {
      this.$confirm('确定要删除该处方吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (id) {
          this.form.deleteItem.deleteStickingPrescriptionIds.push(id);
        }
        this.form.patientStickingDrugGroupList.splice(index, 1);
      }).catch(() => {});
    },
    // 添加附加费用
    additional() {
      const ele = {
        additionalName: '',
        additionalPrice: '',
      };
      this.form.additionalList.push(ele);
    },
    // 删除附加费用
    deleteAdditional(index, id) {
      if (id) {
        this.form.deleteItem.deleteAdditionalIds.push(id);
      }
      this.form.additionalList.splice(index, 1);
    },
    // 获取附加费用
    getHospitalAdditional(type) {
      if (type === 1) this.additionalQuery.currentPage = 1;
      this.$api.clinicManagement.lisTemplate(this.additionalQuery).then((res) => {
        console.log(res);
        this.additionalAll = res.templates;
        this.totalAdditional = res.totalSize || 0;
      });
    },
    // 附加费用翻页
    pageChangeAdditional(e) {
      this.additionalQuery.currentPage = e;
      this.getHospitalAdditional();
    },
    // 载入附加费用
    loadAdditional() {
      this.additionalDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.additionalAll.clearSelection();
      });
      this.additionalQuery.tempName = '';
      this.getHospitalAdditional(1);
    },
    // 勾选附加费用
    handleAdditionalChange(val) {
      this.checkedadditional = val;
    },
    // 选择附加费用
    checkAdditional() {
      console.log(this.checkedadditional);
      this.checkedadditional.forEach((item) => {
        this.form.additionalList.push({
          additionalName: item.tempName,
          additionalPrice: item.tempDesc,
        });
      });
      this.checkedadditional = []; // 清空选项
      this.additionalDialogVisible = false;
    },
    // 选择药品来源
    handleDrugResource() {
      if (this.dataSource === 3) {
        this.form.isDisableCloudDrugBtn = true;
      } else {
        this.form.isDisableCloudDrugBtn = false;
      }
    },

    /* 检查治疗项操作 */
    deleteExamItem(index, id) {
      console.log(id);
      if (id) {
        this.form.deleteItem.deleteExamIds.push(id);
      }
      this.form.examList.splice(index, 1);
      console.log(this.form.deleteItem);
    },
    // 添加检查治疗项
    addExamItem() {
      const ele = {
        examName: '',
        total: 1,
        price: 0.00,
      };
      this.form.examList.push(ele);
    },
    // 载入检查治疗项
    loadExam() {
      this.examDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.examListAll.clearSelection();
      });
      this.examQuery.examName = '';
      this.getHospitalExamList();
    },

    /* 体格检查操作 */
    showPhysicalExam() {
      this.condition.injury.isShowPhysicalInput = !this.condition.injury.isShowPhysicalInput;
    },
    // 添加其他病史
    showOtherExam() {
      this.condition.injury.isShowOtherInput = !this.condition.injury.isShowOtherInput;
    },
    // 打印预览
    printReview(form, name) {
      this.$notify({
        title: '提示',
        message: '正在打开预览...',
        type: 'success',
      });
      this.record = cloneDeep(form);
      // 在门诊功能时取当前医生名
      this.record.realName = this.$store.state.global.countInfo.realName;
      // 诊断的string
      this.record.inquiryInfo.diagnosisResultString = this.record.inquiryInfo.diagnosisResultList
        .map(item => item.diseaseName).join(',');
      this.record.inquiryInfo.doctorName = this.$store.state.global.countInfo.doctorName;
      // 诊断时间
      if (this.record.inquiryInfo.modle === 3) {
        // 补录时间
        this.record.inquiryInfo.clinicalTime = this.record.inquiryInfo.clinicalTime;
      } else {
        this.record.inquiryInfo.clinicalTime = currentDate;
      }
      setTimeout(() => {
        if (name === 'medicineDrugPrescriptionList') this.$refs.medicinePrint.print({
          isReview: true
        });
        if (name === 'patientChineseDrugList') this.$refs.piecesPrint.print({
          isReview: true
        });
        if (name === 'patientInfusionList') this.$refs.infusionPrint.print({
          isReview: true
        });
        if (name === 'patientStickingDrugGroupList') this.$refs.applyPrint.print({
          isReview: true
        });
      }, 100);
    },
    // 完成诊断
    complate(formName, type) {
      this.$refs[formName].validate((valid) => {
        // 判断药品处方中没有药的情况 - 成药处方
        const medicineDrugPrescription = this.form.medicineDrugPrescriptionList.some((item, index) => {
          const hasDrug = item.patientDrugList.every(it => !it.drugName);
          if (hasDrug) {
            this.$message({
              message: `成药处方${index + 1}药品信息不全！`,
              type: 'warning'
            });
            return true;
          }
        });
        if (medicineDrugPrescription) return;
        // 判断药品处方中没有药的情况 - 饮片处方
        const patientChineseDrugList = this.form.patientChineseDrugList.some((item, index) => {
          const hasDrug = item.patientChineseDrugPiecesList.every(it => !it.drugName);
          if (hasDrug) {
            this.$message({
              message: `饮片处方${index + 1}药品信息不全！`,
              type: 'warning'
            });
            return true;
          }
        });
        if (patientChineseDrugList) return;

        // 判断药品处方中没有药的情况 - 输液处方
        const patientInfusionList = this.form.patientInfusionList.some((item, index) => {
          const hasDrug = item.patientInfusionGroupList.every((it) => it.patientDrugList.every(i => !i.drugName));
          if (hasDrug) {
            this.$message({
              message: `输液处方${index + 1}药品信息不全！`,
              type: 'warning'
            });
            return true;
          }
        });
        if (patientInfusionList) return;

        // 判断药品处方中没有药的情况 - 贴敷处方
        const patientStickingDrugGroupList = this.form.patientStickingDrugGroupList.some((item, index) => {
          const hasDrug = item.patientStickingDrugList.every(it => !it.drugName);
          if (hasDrug) {
            this.$message({
              message: `贴敷处方${index + 1}药品信息不全！`,
              type: 'warning'
            });
            return true;
          }
        });
        if (patientStickingDrugGroupList) return;

        if (valid) {
          const form = cloneDeep(this.form);
          let isTrueExam = true;
          if (form.examList.length > 0) {
            const list = form.examList.filter((item) => {
              return item.examName !== '';
            });
            form.examList.forEach((item, index) => {
              if (item.drugName === '') return;
              const isEmpty = item.drugName === '' || !REG_P_INT.test(item.total);
              if (isEmpty) {
                this.$message({
                  message: '检查治疗项的数量填写有误',
                  type: 'error',
                });
                this.$set(this.form.examList[index], 'error', true);
                isTrueExam = false;
              }
            });
            form.examList = list;
          }
          if (!isTrueExam) return;
          let isTrueAddition = true;
          if (form.additionalList.length > 0) {
            form.additionalList.forEach((item, index) => {
              if (item.additionalName === '' && item.additionalPrice === '') return;
              const isEmpty = item.additionalName === '' || !REG_AMT.test(item.additionalPrice);
              if (isEmpty) {
                this.$message({
                  message: '请将附加费用名称及价格补充完整！',
                  type: 'error',
                });
                this.$set(this.form.additionalList[index], 'error', true);
                isTrueAddition = false;
              }
            });
            const list = form.additionalList.filter((item) => {
              return item.additionalName !== '' && item.additionalPrice !== '';
            });
            form.additionalList = list;
          }
          if (!isTrueAddition) return;
          // 成药处方输入验证
          let isTrueMedicineDrug = true;
          if (form.medicineDrugPrescriptionList.length > 0) {
            form.medicineDrugPrescriptionList.forEach((item, index) => {
              item.patientDrugList.forEach((it, indexs) => {
                const list = item.patientDrugList.filter(i => i.drugName !== '');
                if (list.length < 1) {
                  this.$message({
                    message: `请添加成药处方${index + 1}药品`,
                    type: 'error',
                  });
                  isTrueMedicineDrug = false;
                  return;
                }
                if (it.drugName === '' && it.usage === '' && it.frequency === '' && !it
                  .totalDosage && it.totalDosageUnit === '') return;
                const isEmpty = it.drugName === '' || it.usage === '' || it
                  .frequency === '' || it.totalDosage === '' || it.totalDosage <= 0 || !
                  REG_P_INT.test(it.totalDosage) || it.totalDosageUnit === '';
                if (isEmpty) {
                  this.$message({
                    message: `请完善成药处方${index + 1}的信息`,
                    type: 'error',
                  });
                  this.$set(this.form.medicineDrugPrescriptionList[index]
                    .patientDrugList[indexs], 'error', true);
                  isTrueMedicineDrug = false;
                }
              });
            });
          }
          if (!isTrueMedicineDrug) return;
          // 饮片处方输入验证
          let isTrueChineseDrug = true;
          if (form.patientChineseDrugList.length > 0) {
            form.patientChineseDrugList.forEach((item, index) => {
              item.patientChineseDrugPiecesList.forEach((it, indexs) => {
                const list = item.patientChineseDrugPiecesList.filter(i => i
                  .drugName !== '');
                if (list.length < 1) {
                  this.$message({
                    message: `请添加饮片处方${index + 1}药品`,
                    type: 'error',
                  });
                  isTrueChineseDrug = false;
                  return;
                }
                if (it.drugName === '' && !it.value) return;
                const isEmpty = it.drugName === '' || it.value === '' || !it.value || it
                  .value <= 0;
                if (isEmpty) {
                  this.$message({
                    message: `请完善饮片处方${index + 1}的信息`,
                    type: 'error',
                  });
                  this.$set(this.form.patientChineseDrugList[index]
                    .patientChineseDrugPiecesList[indexs], 'error', true);
                  isTrueChineseDrug = false;
                }
              });
            });
          }
          if (!isTrueChineseDrug) return;
          // 输液处方输入验证
          let isTrueInfusionDrug = true;
          if (form.patientInfusionList.length > 0) {
            form.patientInfusionList.forEach((items, index) => {
              items.patientInfusionGroupList.forEach((item, indexs) => {
                item.patientDrugList.forEach((it, indexss) => {
                  const list = item.patientDrugList.filter(i => i.drugName !== '');
                  if (list.length < 1) {
                    this.$message({
                      message: `请添加输液处方${index + 1}组${indexs + 1}药品`,
                      type: 'error',
                    });
                    isTrueInfusionDrug = false;
                    return;
                  }
                  if (it.drugName === '' && it.dosage === '' && it.dosageUnit ===
                    '' && !it.totalDosage && it.totalDosageUnit === '') return;
                  const isEmpty = it.drugName === '' || it.dosage === '' || it
                    .dosageUnit === '' || it.totalDosage === '' || it.totalDosage <=
                    0 || !REG_P_INT.test(it.totalDosage) || it.totalDosageUnit ===
                    '';
                  if (isEmpty) {
                    this.$message({
                      message: `请完善输液处方${index + 1}的信息`,
                      type: 'error',
                    });
                    this.$set(this.form.patientInfusionList[index]
                      .patientInfusionGroupList[indexs].patientDrugList[indexss],
                      'error', true);
                    isTrueInfusionDrug = false;
                  }
                });
              });
            });
          }
          if (!isTrueInfusionDrug) return;
          // 贴敷处方输入验证
          let isTrueStickDrug = true;
          if (form.patientStickingDrugGroupList.length > 0) {
            form.patientStickingDrugGroupList.forEach((item, index) => {
              item.patientStickingDrugList.forEach((it, indexs) => {
                const list = item.patientStickingDrugList.filter(i => i.drugName !==
                  '');
                if (list.length < 1) {
                  this.$message({
                    message: `请添加贴敷处方${index + 1}药品`,
                    type: 'error',
                  });
                  isTrueStickDrug = false;
                  return;
                }
                if (it.drugName === '' && !it.dosage) return;
                const isEmpty = it.drugName === '' || it.dosage === '' || it.dosage <=
                  0 || !it.dosage;
                if (isEmpty) {
                  this.$message({
                    message: `请完善贴敷处方${index + 1}的信息`,
                    type: 'error',
                  });
                  this.$set(this.form.patientStickingDrugGroupList[index]
                    .patientStickingDrugList[indexs], 'error', true);
                  isTrueStickDrug = false;
                }
              });
            });
          }
          if (!isTrueStickDrug) return;
          // 过滤空数据-成药处方
          if (form.medicineDrugPrescriptionList.length > 0) {
            const newList = [];
            form.medicineDrugPrescriptionList.forEach((item) => {
              const list = item.patientDrugList.filter(it => it.drugName !== '');
              if (list.length > 0) {
                newList.push({
                  ...item,
                  patientDrugList: list,
                });
              }
            });
            form.medicineDrugPrescriptionList = newList;
          }
          // 过滤空数据-饮片处方
          if (form.patientChineseDrugList.length > 0) {
            const newList = [];
            form.patientChineseDrugList.forEach((item) => {
              const list = item.patientChineseDrugPiecesList.filter(it => it.drugName !==
                '');
              if (list.length > 0) {
                newList.push({
                  ...item,
                  patientChineseDrugPiecesList: list,
                });
              }
            });
            form.patientChineseDrugList = newList;
          }
          // 过滤空数据-输液处方
          if (form.patientInfusionList.length > 0) {
            const newList = [];
            form.patientInfusionList.forEach((items) => {
              const lists = [];
              items.patientInfusionGroupList.forEach((item) => {
                const list = item.patientDrugList.filter(it => it.drugName !== '');
                if (list.length > 0) {
                  lists.push({
                    ...item,
                    patientDrugList: list,
                  });
                }
              });
              newList.push({
                ...items,
                patientInfusionGroupList: lists,
              });
            });
            form.patientInfusionList = newList;
          }
          // 过滤空数据-贴敷处方
          if (form.patientStickingDrugGroupList.length > 0) {
            const newList = [];
            form.patientStickingDrugGroupList.forEach((item) => {
              const list = item.patientStickingDrugList.filter(it => it.drugName !== '');
              if (list.length > 0) {
                newList.push({
                  ...item,
                  patientStickingDrugList: list,
                });
              }
            });
            form.patientStickingDrugGroupList = newList;
          }
          const list = []; // 诊断结构
          form.inquiryInfo.diagnosisResultList.forEach((item) => {
            if (item.diseaseName) {
              list.push(item);
            } else {
              list.push({
                diseaseName: item
              });
            }
          });
          form.inquiryInfo.diagnosisResultList = list; // 诊断字符串
          console.log(form.inquiryInfo.diagnosisResultList);
          form.inquiryInfo.modle = this.type === '' ? 1 : 3; // 类型：3：补写
          // 上传附件格式
          form.inquiryInfo.inquiryAttachmentList = this.fileList2.map(item => ({
            fileName: item.name.substring(0, item.name.lastIndexOf('.')),
            fileType: item.name.substring(item.name.lastIndexOf('.') + 1),
            newUri: item.url,
          }));
          if (this.attr && this.attr.length > 0) {
            console.log(this.$refs.attr);
            console.log(this.attr);
            const cityArr = {
              province: this.$refs.attr.currentLabels && this.$refs.attr.currentLabels.length > 2 ? this.$refs.attr.currentLabels[0] : '',
              provinceCode: this.attr[0],
              city: this.$refs.attr.currentLabels && this.$refs.attr.currentLabels.length > 2 ? this.$refs.attr.currentLabels[1] : '',
              cityCode: this.attr[1],
              district: this.$refs.attr.currentLabels && this.$refs.attr.currentLabels.length > 2 ? this.$refs.attr.currentLabels[2] : '',
              districtCode: this.attr[2],
            };
            form.patient = Object.assign(this.form.patient, cityArr);
          } else {
            const cityArr = {
              province: '',
              provinceCode: '',
              city: '',
              cityCode: '',
              district: '',
              districtCode: '',
            };
            form.patient = Object.assign(this.form.patient, cityArr);
          }
          // 非类型进行操作
          if (type === 'complate') this.saveRecord(form);
          if (type === 'print') {
            this.isDisabledPrint = true;
            setTimeout(() => {
              this.isDisabledPrint = false;
            }, 2000);
            this.printScript(form, type);
          }
          if (type === 'record') this.printScript(form, type);
          if (type === 'printInfusionCard') this.printInfusionCard(form);
          const redFruits = ['medicineDrugPrescriptionList', 'patientChineseDrugList',
            'patientInfusionList', 'patientStickingDrugGroupList'
          ];
          if (redFruits.includes(type)) {
            this.printReview(form, type);
          }
        } else {
          this.$message({
            message: '请填写必填项！',
            type: 'error',
          });
          return false;
        }
      });
    },
    // 保存病历
    saveRecord(form) {
      // 年龄处理 如果是空字符串转 0
      if (this.form.patient.year === '') this.form.patient.year = 0;
      if (this.form.patient.month === '') this.form.patient.month = 0;
      if (this.form.patient.day === '') this.form.patient.day = 0;
      this.$api.outPatient.saveRecord(form).then((res) => {
        console.log(res);
        if (res === -1) return; // 报错返回-1
        this.$message({
          message: '保存成功',
          type: 'success',
        });
        // 删除病历
        if (this.delFiles.length > 0) {
          this.delteteFiles();
        }
        this.$refs.form.resetFields();
        this.form = cloneDeep(this.newform); // 重置表单
        this.ageForm = {
          showYear: true,
          showMonth: false,
          showDay: false,
        };
        this.attr = []; // 清空地址信息
        this.paitentDisable = false;
        this.listRecentPrescription();
        this.isClearPatient = false; // 隐藏删除按钮
        this.fileList2 = []; // 清空病历附件
        this.paitentRecord = []; // 单个患者历史病历列表
        this.paitentRecordDetial = {}; // 单个患者历史病历详情
        document.getElementById('right-content').scrollTo(0, 0); // 页面滚动条滚动到顶部
      });
    },
    // 药品单项合计金额
    drugAmt(price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return '0.00';
      return BN(price).multipliedBy(num).toFixed(3);
    },
    // 药品单项合计金额-返回0
    drugAmtSub(price, num) {
      const priceNumber = Number(price);
      const numNumber = Number(num);
      if (!priceNumber || isNaN(priceNumber) || isNaN(numNumber) || !numNumber) return 0;
      return BN(price).multipliedBy(num).toFixed(3);
    },
    // 改变药品单位获取药品价格-成药
    changePrice(e, index, indexs) {
      if (this.form.medicineDrugPrescriptionList[index].patientDrugList[indexs].drugSalePojos) {
        const drugSale = this.form.medicineDrugPrescriptionList[index].patientDrugList[indexs]
          .drugSalePojos.find(item => item.unitName === e);
        this.form.medicineDrugPrescriptionList[index].patientDrugList[indexs].univalence = drugSale
          .drugSalePrice;
      }
    },
    // 改变药品单位获取药品价格-输液
    changePriceIn(e, index, indexs, drugindex) {
      if (this.form.patientInfusionList[index].patientInfusionGroupList[indexs].patientDrugList[
          drugindex].drugSalePojos) {
        const drugSale = this.form.patientInfusionList[index].patientInfusionGroupList[indexs]
          .patientDrugList[drugindex].drugSalePojos.find(item => item.unitName === e);
        this.form.patientInfusionList[index].patientInfusionGroupList[indexs].patientDrugList[
          drugindex].univalence = drugSale.drugSalePrice;
      }
    },
    // 开药量单位下拉选择-输液
    setDosageInUnit(list, index, indexs, drugindex) {
      if (!list || list === '') {
        this.$api.drugControl.searchDictionary({
          type: 4,
          cnName: '',
        }).then((res) => {
          const lists = res.dictList.map(item => ({
            unitName: item.cnName
          }));
          if (res.dictList.length > 0) {
            this.$set(this.form.patientInfusionList[index].patientInfusionGroupList[indexs]
              .patientDrugList[drugindex], 'drugSalePojos', lists);
          }
        });
      }
    },
    // 获取用药频率每日对应次数
    getFrequency(frequencyVal, index, indexs) {
      let num = 1;
      if (frequencyVal !== '') {
        // 过滤频次数据
        let matchStr = '';
        let start = frequencyVal.indexOf('(');
        const end = frequencyVal.indexOf(')');
        if (start > 0) {
          start += 1;
        }
        matchStr = frequencyVal.substring(start, end);
        // qd---1日1次，bid---1日2次，tid---1日3次，qid---1日4次
        switch (matchStr) {
          case 'qd':
            num = 1;
            break;
          case 'bid':
            num = 2;
            break;
          case 'tid':
            num = 3;
            break;
          case 'qid':
            num = 4;
            break;
          default:
            num = 1;
            break;
        }
      }
      if (index !== undefined && indexs !== undefined) {
        this.form.patientInfusionList[index].patientInfusionGroupList[indexs].frequency = num;
      }
      return num;
    },
    // 获取单个成药处方价格总和
    getGroupMedicineDrugAmt(list) {
      const sub = list.patientDrugList.reduce((a, b) => {
        const salePrice = Number(b.univalence);
        const dosage = Number(b.totalDosage);
        return BN(a).plus(Number(this.drugAmtSub(salePrice, dosage))).toFixed(3);
      }, 0);
      return sub;
    },
    // 获取单个饮片处方价格总和
    getGroupChineseDrugAmt(list) {
      const sub = list.patientChineseDrugPiecesList.reduce((a, b) => {
        const salePrice = Number(b.univalence);
        const dosage = Number(b.value);
        return BN(a).plus(Number(this.drugAmtSub(salePrice, dosage))).toFixed(3);
      }, 0);
      return sub;
    },
    // 获取单个输液组价格总和
    getGroupTotalAmt(list) {
      const sub = list.patientDrugList.reduce((a, b) => {
        const salePrice = Number(b.univalence);
        const dosage = Number(b.totalDosage);
        return BN(a).plus(Number(this.drugAmtSub(salePrice, dosage))).toFixed(3);
      }, 0);
      return sub;
    },
    // 获取单个输液处方价格总和
    getInfusionListAmt(list) {
      const sub = this.getGroupTotalAmt(list);
      const frequency = this.getFrequency(list.useRate);
      return BN(sub).multipliedBy(frequency).multipliedBy(list.dayCount).toFixed(3);
    },
    // 开药量单位下拉选择setDosageInUnit
    setDosageUnit(list, index, indexs) {
      if (!list || list === '') {
        this.$api.drugControl.searchDictionary({
          type: 4,
          cnName: '',
        }).then((res) => {
          console.log(res);
          const lists = res.dictList.map(item => ({
            unitName: item.cnName
          }));
          if (res.dictList.length > 0) {
            this.$set(this.form.medicineDrugPrescriptionList[index].patientDrugList[indexs],
              'drugSalePojos', lists);
          }
        });
      }
    },
    // 清空检查治疗项id和价格
    checkDrugExam(index) {
      this.form.examList[index].examId = '';
      this.form.examList[index].price = '0.00';
    },
    // 清空饮片id和价格
    checkDrug(index, drugindex) {
      this.form.patientChineseDrugList[index].patientChineseDrugPiecesList[drugindex].drugId = '';
      this.form.patientChineseDrugList[index].patientChineseDrugPiecesList[drugindex].dataSource =
        '';
      this.form.patientChineseDrugList[index].patientChineseDrugPiecesList[drugindex].univalence =
        '0.00';
      this.$set(this.form.patientChineseDrugList[index].patientChineseDrugPiecesList[drugindex],
        'inventoryCount', 0); // 清空库存
    },
    // 清空成药id、价格、开药量单位下拉选项,厂家，规格
    checkDrugCom(index, drugindex) {
      this.form.medicineDrugPrescriptionList[index].patientDrugList[drugindex].drugId = '';
      this.form.medicineDrugPrescriptionList[index].patientDrugList[drugindex].dataSource = '';
      this.form.medicineDrugPrescriptionList[index].patientDrugList[drugindex].univalence = '0.00';
      this.$set(this.form.medicineDrugPrescriptionList[index].patientDrugList[drugindex],
        'drugSalePojos', '');
      this.$set(this.form.medicineDrugPrescriptionList[index].patientDrugList[drugindex],
        'inventoryCount', 0); // 清空库存
      this.$set(this.form.medicineDrugPrescriptionList[index].patientDrugList[drugindex],
        'drugUnitPojo', null);
      this.form.medicineDrugPrescriptionList[index].patientDrugList[drugindex].manufacturer = '';
      this.form.medicineDrugPrescriptionList[index].patientDrugList[drugindex].specification = '';
    },
    // 清空输液药品id、价格、开药量单位下拉选项
    checkDrugIn(index, indexs, drugindex) {
      this.form.patientInfusionList[index].patientInfusionGroupList[indexs].patientDrugList[
        drugindex].drugId = '';
      this.form.patientInfusionList[index].patientInfusionGroupList[indexs].patientDrugList[
        drugindex].dataSource = '';
      this.form.patientInfusionList[index].patientInfusionGroupList[indexs].patientDrugList[
        drugindex].univalence = '0.00';
      this.$set(this.form.patientInfusionList[index].patientInfusionGroupList[indexs]
        .patientDrugList[drugindex], 'drugSalePojos', '');
      this.$set(this.form.patientInfusionList[index].patientInfusionGroupList[indexs]
        .patientDrugList[drugindex], 'drugUnitPojo', null); // 清空价格层级关系
      this.$set(this.form.patientInfusionList[index].patientInfusionGroupList[indexs]
        .patientDrugList[drugindex], 'inventoryCount', 0);
      // this.form.patientInfusionList[index].patientInfusionGroupList[indexs].patientDrugList[drugindex].drugSalePojos = '';
    },
    // 清空贴敷id
    checkDrugStick(index, drugindex) {
      this.form.patientStickingDrugGroupList[index].patientStickingDrugList[drugindex].drugId = '';
      this.form.patientStickingDrugGroupList[index].patientStickingDrugList[drugindex].dataSource =
        '';
      this.$set(this.form.patientStickingDrugGroupList[index].patientStickingDrugList[drugindex],
        'inventoryCount', 0);
    },
    // 判断当前输入数量是否超出库存-成药（库存、数量、单位、单位层级关系）
    countComCn(inventoryCount, totalDosage, unit, drugSalePojos) {
      const salePojos = [];
      let isShow = false;
      const total = totalDosage > 0 ? totalDosage : 1;
      if (drugSalePojos) {
        salePojos.push({
          drugRatio: drugSalePojos.drugRatio,
          unitName: drugSalePojos.unitName,
        });
        if (drugSalePojos.parentUnit !== '' && drugSalePojos.parentUnit) {
          salePojos.push({
            drugRatio: drugSalePojos.parentUnit.drugRatio,
            unitName: drugSalePojos.parentUnit.unitName,
          });
          if (drugSalePojos.parentUnit.parentUnit !== '' && drugSalePojos.parentUnit.parentUnit) {
            salePojos.push({
              drugRatio: drugSalePojos.parentUnit.parentUnit.drugRatio,
              unitName: drugSalePojos.parentUnit.parentUnit.unitName,
            });
          }
        }
      }
      // 开药量修改 判断是否符合库存
      if (unit !== '' && salePojos.length > 1) {
        salePojos.forEach((item) => {
          if (item.unitName === unit) {
            console.log(totalDosage * item.drugRatio > inventoryCount);
            isShow = totalDosage * item.drugRatio > inventoryCount;
          }
        });
      } else if (inventoryCount <= 0 || inventoryCount < total) {
        isShow = true;
      }
      return isShow;
    },
    // 判断当前输入数量是否超出库存-输液(库存、数量、连续天数、用药频率、单位、单位层级关系)
    countComIn(inventoryCount, totalDosage, dayCount, useRate, unit, drugSalePojos) {
      const salePojos = []; // 包装层级
      let useR = 1; // 每日次数
      if (useRate) {
        useR = this.getFrequency(useRate);
      }
      const total = totalDosage > 0 ? totalDosage : 1; // 数量
      if (drugSalePojos) {
        salePojos.push({
          drugRatio: drugSalePojos.drugRatio,
          unitName: drugSalePojos.unitName,
        });
        if (drugSalePojos.parentUnit !== '') {
          salePojos.push({
            drugRatio: drugSalePojos.parentUnit.drugRatio,
            unitName: drugSalePojos.parentUnit.unitName,
          });
          if (drugSalePojos.parentUnit.parentUnit !== '') {
            salePojos.push({
              drugRatio: drugSalePojos.parentUnit.parentUnit.drugRatio,
              unitName: drugSalePojos.parentUnit.parentUnit.unitName,
            });
          }
        }
      }
      let drugRatio = 1; // 换算比
      let com = 0;
      // 开药量修改 判断是否符合库存
      if (unit !== '' && salePojos.length > 1) {
        salePojos.forEach((item) => {
          if (item.unitName === unit) {
            drugRatio = Number(item.drugRatio);
          }
        });
      }
      if (totalDosage && useRate) {
        com = dayCount * total * useR; // 连续天数*数量*每日次数
      } else if (totalDosage) {
        com = dayCount * total;
      } else {
        com = total;
      }
      return drugRatio * com > inventoryCount;
    },
    // 判断当前输入数量是否超出库存（库存、数量、剂数、用药频率）
    countCom(inventoryCount, value, totalDosage, useRate) {
      const total = totalDosage > 0 ? totalDosage : 1;
      let useR = 1;
      if (useRate) {
        useR = this.getFrequency(useRate);
      }
      if (totalDosage && useRate) {
        if (inventoryCount <= 0 || inventoryCount < value * total * useR) return true;
      } else if (totalDosage) {
        if (inventoryCount <= 0 || inventoryCount < value * total) return true;
      } else if (inventoryCount <= 0 || inventoryCount < value) {
        return true;
      }
      return false;
    },
    // 判断当前输入药品名是否来自药品库 flag：是否删除 1正常 0 删除
    checkDrugName(name, id, flag) {
      if (name === '' || (id && flag !== 0)) return false;
      return true;
    },
    // 数量赋值-西药
    setCount(value, index, indexs) {
      if (value === '') return;
      this.form.medicineDrugPrescriptionList[index].patientDrugList[indexs].totalDosage = Number(
        value);
    },
    // 数量赋值-饮片
    setCountCn(value, index, indexs) {
      if (value === '') return;
      this.form.patientChineseDrugList[index].patientChineseDrugPiecesList[indexs].value = Number(
        value);
    },
    // 数量赋值-输液
    setCountIn(value, index, indexs, drugindex) {
      if (value === '') return;
      this.form.patientInfusionList[index].patientInfusionGroupList[indexs].patientDrugList[
        drugindex].totalDosage = Number(value);
    },
    // 数量赋值-贴敷
    setCountSk(value, index, indexs) {
      if (value === '') return;
      this.form.patientStickingDrugGroupList[index].patientStickingDrugList[indexs].dosage = Number(
        value);
    },
    // 添加皮试
    addSkinTest(index, indexs, drugindex) {
      if (this.form.patientInfusionList[index].patientInfusionGroupList[indexs].patientDrugList[
          drugindex].skinTest === '' || !this.form.patientInfusionList[index]
        .patientInfusionGroupList[indexs].patientDrugList[drugindex].skinTest) {
        this.$set(this.form.patientInfusionList[index].patientInfusionGroupList[indexs]
          .patientDrugList[drugindex], 'skinTest', '皮试');
      }
    },
    // 删除病历附件-后台删除
    delteteFiles() {
      this.$api.outPatient.deleteFile({
        ossUrlList: this.delFiles,
      }).then(() => {});
    },
    // 删除病历附件-页面删除
    handleRemove(file) {
      console.log(file);
      this.delFiles.push(file.url);
      const list = this.fileList2.filter((item) => {
        return item.url !== file.url;
      });
      this.fileList2 = list;
      console.log(this.fileList2);
    },
    beforeAvatarUpload(file) {
      const isFile = file.type === 'image/jpeg' || file.type === 'application/msword' || file
        .type === 'image/bmp' || file.type === 'image/png' || file.type === 'application/pdf' ||
        file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      const isLt2M = file.size / 1024 / 1024 < 5;
      console.log(file.type);
      if (!isFile) {
        this.$message.error('请检查附件格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 5MB!');
      }
      return isFile && isLt2M;
    },
    // 上传病历成功
    handleAvatarSuccess(res, file) {
      console.log(file);
      const files = JSON.parse(file.response);
      // let arr = '';
      if (files.errorCode === 0 && files.data.length > 0) {
        // arr = files.data[0].split('/').pop();
        this.fileList2.push({
          name: file.name,
          url: files.data[0],
        });
      } else {
        this.$message.error('上传失败!');
        console.log(file);
        this.fileList2.pop();
      }
    },
    // 上传文件超过限制
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    // 添加样式
    generateClassName(index, value, error) {
      if ((value === '' || !value || value <= 0) && error) {
        return `error-hint value-input${index}`;
      }
      return `value-input${index}`;
    },
    // 年龄处理
    yearHandle() {
      const val = this.form.patient.year;
      if (val < 5 && val > 0) {
        this.ageForm.showMonth = true;
      }
      if (val === 0) {
        this.ageForm.showYear = false;
        this.ageForm.showMonth = true;
        this.ageForm.showDay = true;
      }
      if (val >= 5) {
        this.ageForm.showYear = true;
        this.ageForm.showMonth = false;
        this.ageForm.showDay = false;
        this.form.patient.month = 0;
        this.form.patient.day = 0;
      }
      if (this.form.patient.year > 0 && this.form.patient.year < 5) {
        this.ageForm.showYear = true;
        this.ageForm.showMonth = true;
        this.ageForm.showDay = false;
        this.form.patient.day = 0;
      }
    },
    monthHandle() {
      const val = this.form.patient.month;
      if (val >= 12) {
        const month = val % 12;
        const year = parseInt(val / 12);
        this.form.patient.year = this.form.patient.year + year;
        this.form.patient.month = month;
      }
      this.yearHandle();
    },
    dayHandle() {
      const val = this.form.patient.day;
      if (val >= 30) {
        const day = val % 30;
        const month = parseInt(val / 30);
        this.form.patient.month = this.form.patient.month + month;
        this.form.patient.day = day;
      }
      this.monthHandle();
      this.yearHandle();
    },
  },
  filters: {
    // 处方模板类型 1-个人处方模板 2-诊所处方模板3-个人处方模板+诊所处方模板
    setTempAuthority(type) {
      let tempAuthority = '';
      switch (type) {
        case 1:
          tempAuthority = '个人';
          break;
        case 2:
          tempAuthority = '诊所';
          break;
        case 3:
          tempAuthority = '全部';
          break;
        default:
          tempAuthority = '';
          break;
      }
      return tempAuthority;
    },
  },
  computed: {
    // 历史病历是否为空
    isEmptyPaitentRecordDetial() {
      const arr = Object.keys(this.paitentRecordDetial);
      return arr.length === 0; // true
    },
    // 最近处方是否为空
    isEmptyRecordDetial() {
      const arr = Object.keys(this.recordDetial);
      return arr.length === 0; // true
    },
    // 检查项合计总价
    examAmt() {
      const sub = this.form.examList.reduce((a, b) => {
        const salePrice = Number(b.price);
        const dosage = Number(b.total);
        let result = 0;
        if (salePrice && !isNaN(salePrice) && dosage && !isNaN(dosage)) {
          result = BN(b.price).multipliedBy(b.total).toFixed(3);
        }
        return a + Number(result);
      }, 0);
      return sub;
    },
    // 总价
    getTotalAmt() {
      let result = 0;
      const subExamAmt = this.examAmt; // 检查治疗项费用总和
      const subAdditionalList = this.form.additionalList.reduce((a, b) => {
        return a + Number(b.additionalPrice);
      }, 0); // 附加费用总和
      const subMedicineDrugPrescriptionList = this.form.medicineDrugPrescriptionList.reduce((a,
        b) => {
        const sub = b.patientDrugList.reduce((c, d) => {
          const salePrice = Number(d.univalence);
          const dosage = Number(d.totalDosage);
          return c + Number(this.drugAmtSub(salePrice, dosage));
        }, 0);
        return a + Number(sub);
      }, 0); // 成药处方费用总和
      const subPatientChineseDrugList = this.form.patientChineseDrugList.reduce((a, b) => {
        const sub = b.patientChineseDrugPiecesList.reduce((c, d) => {
          const salePrice = Number(d.univalence);
          const dosage = Number(d.value);
          return c + Number(this.drugAmtSub(salePrice, dosage));
        }, 0);
        const totalDosage = Number(b.totalDosage) || 1; // 剂量
        const results = BN(sub).multipliedBy(Number(totalDosage));
        return a + Number(results);
      }, 0); // 饮片处方费用总和
      const subPatientInfusionList = this.form.patientInfusionList.reduce((a, b) => {
        const sub = b.patientInfusionGroupList.reduce((c, d) => {
          return c + Number(this.getInfusionListAmt(d));
        }, 0);
        return a + Number(sub);
      }, 0); // 输液处方费用总和
      const subPatientStickingDrugGroupList = this.form.patientStickingDrugGroupList.reduce((a,
        b) => {
        const salePrice = Number(b.retailPrice);
        const dosage = Number(b.count);
        return a + Number(this.drugAmtSub(salePrice, dosage));
      }, 0); // 贴敷处方费用总和
      if (subExamAmt !== 0) result = BN(result).plus(subExamAmt);
      if (subAdditionalList !== 0) result = BN(result).plus(subAdditionalList);
      if (subMedicineDrugPrescriptionList !== 0) result = BN(result).plus(
        subMedicineDrugPrescriptionList);
      if (subPatientChineseDrugList !== 0) result = BN(result).plus(subPatientChineseDrugList);
      if (subPatientInfusionList !== 0) result = BN(result).plus(subPatientInfusionList);
      if (subPatientStickingDrugGroupList !== 0) result = BN(result).plus(
        subPatientStickingDrugGroupList);
      this.form.inquiryInfo.price = BN(result).toFixed(3); // 病历总价
      return BN(result).toFixed(3);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.form.patient.patientName || this.form.patient.age || this.form.patient.phoneNo || this
      .form.inquiryInfo.diagnosisResultList.length > 0) {
      this.$confirm('有内容未保存，确定离开此页吗?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        next();
      }).catch(() => {
        next(false);
      });
    } else {
      next();
    }
  },
};
